import * as Api from './api';

const OAUTH_TOKEN = (service: string) => `/authorize/${service}/token`;
export class UserApiClient {
  username: string;

  constructor(username: string) {
    this.username = username;
  }

  update = (update: UpdateUserRequest) =>
    Api.post(this.getUserRoute(), {
      body: JSON.stringify(update),
    });

  getUserRoute = (route?: string) => `/users/${this.username}${route || ''}`;

  disable = () => Api.post(`${this.getUserRoute('/disable')}`);

  enable = () => Api.post(`${this.getUserRoute('/enable')}`);

  getResetLink = () => Api.get(`${this.getUserRoute('/reset-link')}`);

  sendNewUserEmail = () => Api.post(`${this.getUserRoute('/send-reset-email')}`);

  setToken = (service: string, code: string) =>
    Api.post(`${this.getUserRoute(OAUTH_TOKEN(service))}`, {
      body: JSON.stringify({ code }),
    });

  scheduleEvent = (event: any) =>
    Api.post(`${this.getUserRoute('/schedule-event')}`, {
      body: JSON.stringify({ event }),
    });

  updateCalendarPreferences = (calendarType: string | null, otherCalendar: string | null) =>
    Api.post(`${this.getUserRoute('/calendar-preferences')}`, {
      body: JSON.stringify({ calendarType, otherCalendar }),
    });

  sharedApplicants = () => Api.get(`${this.getUserRoute('/shared-emails')}`);

  pusherAuth = (socketId: string, channelName: string) =>
    Api.post(`${this.getUserRoute('/pusher/auth')}`, {
      body: JSON.stringify({ socketId, channelName }),
    });

  static logAccess = () => Api.post('/user/access');

  static loadAdminUsers = () => Api.get('/admins');

  static create = (user: UserRequest) =>
    Api.post('/users', {
      body: JSON.stringify(user),
    });

  static all = (accountId: number) => Api.get(`/users?accountId=${accountId}`);
}
